import {IAgreementParser, IParsedAgreement} from './agreementParser';

export default class BaseParser implements IAgreementParser {
	public static CardTextClass = 'card-text';

	protected signatureSelector = '#AgreementHeader';
	protected readonly $: JQueryStatic;
	protected readonly baseUrl: string;
	protected title?: string;

	constructor(jquery: JQueryStatic, baseUrl: string) {
		this.$ = jquery;
		this.baseUrl = baseUrl;
	}

	public parse(agreement: MyAccountApi.IAgreement, source: string): IParsedAgreement {
		const $agreementHtml: JQuery = $(agreement.agreementHtml);
		const agreementPdf: string = agreement.agreementPdf;
		const $agreement: JQuery = $('<div></div>').append($agreementHtml);
		let $title: JQuery;
		let $body: JQuery;
		let $footer: JQuery;
		let $signature: JQuery;
		const status = agreement.agreementSummary != null ? agreement.agreementSummary.agreementStatus : undefined;
		const signature: string = agreement.agreementSignature;
		this.title = agreement.type != null ? (agreement.type || 'Agreement') : undefined;

		$title = this.parseTitle($agreement, source);
		$signature = this.parseSignature($agreement, source);
		if (agreement.type === 'application/pdf') {
			$body = $('<div class="col-xs-12"></div>').append(this.parsePdf(agreementPdf, source));
		} else {
			$body = $('<div class="col-xs-12"></div>').append(this.parseBody($agreement, source));
		}
		$footer = this.parseFooter(status, signature);

		return {
			body: $('<div>').append($body).html(),
			footer: $footer.html(),
			signature: $signature.html(),
			title: $title.text() || this.title || ''
		};
	}

	protected parseBody($agreement: JQuery, source: string): JQuery {
		throw new Error('Abstract method not implemented');
	}

	protected parsePdf(pdf: string, source: string): JQuery {
		throw new Error('Abstract method not implemented');
	}

	protected parseFooter(status?: string, signature?: string): JQuery {
		const $footer = $('<div>');
		const $text = $(`<p class="col-xs-12 ${BaseParser.CardTextClass}">`);

		if (signature) {
			const imgSrc = `data:image/png;base64,${signature}`;
			const $image = $(`<img alt="Signature Image" src="${imgSrc}"/>`);
			$footer.append($image);
		} else if (status === 'SIGNATURE_ON_FILE') {
			$text.text('Signature on file');
			$footer.append($text);
		} else if (status === 'SIGNATURE_FROM_INTERNET') {
			$text.text('Member accepted through internet');
			$footer.append($text);
		} else if (status === 'SIGNATURE_FROM_TELEPHONE') {
			$text.text('Requested in writing - document on file');
			$footer.append($text);
		}

		return $footer;
	}

	protected parseTitle($agreement: JQuery, source: string): JQuery {
		return $('');
	}

	protected parseSignature($agreement: JQuery, source: string): JQuery {
		return $('');
	}
}
